import { toast } from "sonner";
import { api, C } from "./api";

const route = (uid) => C.ApiRoutes.PLAYER_FRIEND.replace("{user_id}", uid);

export const sendFriendRequest = (uid) => api.post(route(uid));
export const removeFriend = (uid) => api.delete(route(uid));

// One toast per incoming request, with Accept / Decline right in it (table and lobby use the same one).
export function friendRequestToast(from, onDone) {
  toast(`${from.display_name} wants to add you as a friend`, {
    id: `friend-${from.user_id}`,
    description: from.tag,
    duration: 20000,
    action: { label: "Accept", onClick: () => sendFriendRequest(from.user_id).then(() => { toast.success(`You and ${from.display_name} are now friends`); onDone?.("friends"); }).catch(() => {}) },
    cancel: { label: "Decline", onClick: () => removeFriend(from.user_id).then(() => onDone?.("none")).catch(() => {}) },
  });
}

export const loadPendingRequests = (onDone) =>
  api.get(C.ApiRoutes.FRIEND_REQUESTS).then((r) => r.data.forEach((req) => friendRequestToast(req.from, onDone))).catch(() => {});
